import React from 'react';
import SEO from '../components/SEO';

export default function AntiSlaveryPage() {
  return (
    <div data-testid="anti-slavery-page">
      <SEO
        title="Anti-Slavery Policy"
        description="Glossop & District Round Table 916's zero-tolerance approach to modern slavery and human trafficking."
        path="/policies/anti-slavery"
        keywords={['anti-slavery policy', 'modern slavery', 'Glossop Round Table policy']}
      />

      <div className="pt-28 sm:pt-32 pb-20 sm:pb-28 bg-white min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Human Rights</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] mb-8">
            Anti-Slavery Policy
          </h1>
          <p className="text-base text-[#52525B] leading-relaxed mb-6 italic">
            Our zero-tolerance approach to modern slavery
          </p>

          <div className="space-y-8 text-base text-[#52525B] leading-relaxed">
            <div>
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-3">Overview</h3>
              <p className="mb-4">
                Modern slavery is a crime and a violation of fundamental human rights. We have a zero-tolerance approach to modern slavery and we are committed to acting ethically and with integrity in all our dealings and relationships.
              </p>
              <p className="mb-4">
                Modern slavery takes various forms, such as slavery, servitude, forced and compulsory labour and human trafficking, all of which have in common the deprivation of a person's liberty by another to exploit them for personal or commercial gain.
              </p>
              <p>
                We are committed to implementing and enforcing effective systems and controls to ensure modern slavery is not taking place anywhere in our own organisation or in any of our supply chains. We are also committed to ensuring transparency throughout our supply chains, consistent with our obligations under the Modern Slavery Act 2015.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Policy Responsibility</h2>
              <p>
                Our Compliance Officer has primary and day-to-day responsibility for implementing this policy, monitoring its use and effectiveness, dealing with any queries about it and auditing internal control, systems and procedures to ensure they are effective in countering modern slavery.
              </p>
              <p className="mt-4">
                Management at all levels are responsible for ensuring those reporting to them understand and comply with this policy and are given adequate and regular training on the issue of modern slavery in supply chains.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Individual Responsibility</h2>
              <p className="mb-4">
                All individuals must read, understand and comply with this policy. The prevention, detection and reporting of modern slavery in any part of our organisation or supply chains is the responsibility of all those working for us or under our control.
              </p>
              <p>
                Individuals are required to avoid any activity that might lead to, or suggest, a breach of this policy. The Compliance Officer must be notified as soon as possible if an individual believes or suspects that a conflict with this policy has occurred or may occur in the future.
              </p>
            </div>

            <div className="p-6 bg-[#F4F4F5] border-l-4 border-[#F0A500]">
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Reporting Concerns</h3>
              <p>
                Individuals are encouraged to raise concerns about any issue or suspicion of modern slavery at the earliest possible stage. If you believe or suspect any breach of this policy has occurred, or that it may occur, it should be reported to{' '}
                <a href="mailto:info@glossoproundtable.org" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">
                  info@glossoproundtable.org
                </a>
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Our Commitment</h2>
              <p>
                We aim to encourage openness and will support anyone who raises genuine concerns in good faith under this policy. We are committed to ensuring no one suffers any detrimental treatment due to reporting in good faith their suspicion that modern slavery of whatever form is or may be taking place in any part of our organisation or in any of our supply chains.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-[#0A0A0A] mb-3">Breach of this policy</h3>
              <p>
                Any individual who breaches this policy will face appropriate action. We may terminate our relationship with other individuals and organisations working on our behalf if they breach this policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
